export const generateLoadingPrint = (data) => {
  // Validate data structure
  if (!data || !data.vehicle_id) {
    console.error("Invalid data structure for printing:", data);
    alert("Unable to generate print preview. Invalid data structure.");
    return;
  }

  const printWindow = window.open("", "_blank");

  if (!printWindow) {
    console.error("Failed to open new window for printing");
    alert("Please allow pop-ups to print the document");
    return;
  }

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Vehicle Loading Details</title>
      <meta charset="utf-8">
      <style>
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        body {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
          background-color: white;
          padding: 0px;
        }

        /* Stats Cards Specific Styles */
        .stats-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 12px;
          margin-bottom: 20px;
        }

        .stat-card {
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }

        .stat-content {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          width: 100%;
        }

        .stat-label {
          font-size: 0.875rem;
          color: #6b7280;
          margin: 0 !important;
        }

        .stat-value {
          font-size: 1.5rem;
          font-weight: bold;
          margin: 0 !important;
        }

        .weight-container {
          display: flex;
          align-items: baseline;
          gap: 4px;
        }

        .weight-unit {
          font-size: 0.75rem;
          color: #6b7280;
        }

        /* Vehicle Header */
        .vehicle-header {
          border: 1px solid #e5e7eb;
          border-radius: 8px;
          padding: 12px;
          margin-bottom: 16px;
          background-color: #f9fafb;
        }

        /* Table Styles */
        .shipments-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 16px;
          font-size: 0.75rem;
        }

        .shipments-table th {
          background-color: #f9fafb;
          font-weight: 600;
          padding: 6px 12px;
          border-bottom: 1px solid #e5e7eb;
          text-align: left;
          font-size: 0.7rem;
        }

        .shipments-table td {
          padding: 6px 12px;
          border-bottom: 1px solid #e5e7eb;
          font-size: 0.7rem;
        }

        .shipments-table tr:hover {
          background-color: #f9fafb;
        }

        /* Print Header */
        .print-header {
          text-align: center;
          margin-bottom: 24px;
          border-bottom: 2px solid #e5e7eb;
          padding-bottom: 16px;
        }

        /* Print Button */
        .print-button-container {
          position: fixed;
          top: 20px;
          right: 20px;
          z-index: 9999;
        }

        .print-button {
          background-color: #3b82f6;
          color: white;
          border: none;
          padding: 12px 24px;
          border-radius: 8px;
          cursor: pointer;
        }

        @media print {
          .no-print {
            display: none !important;
          }
          
          body {
            padding: 0;
          }
          
          .stat-card {
            box-shadow: none;
          }
        }
      </style>
    </head>
    <body>
      <div class="print-button-container no-print">
        <button class="print-button" onclick="window.print()">
          Print Document
        </button>
      </div>
      <div id="print-content"></div>
    </body>
    </html>
  `);

  printWindow.document.close();

  // Wait for window to load
  setTimeout(() => {
    const contentRoot = printWindow.document.getElementById("print-content");

    if (contentRoot) {
      // Create a simple HTML structure instead of using React components
      const printDate = new Date().toLocaleString();

      contentRoot.innerHTML = `
        <div class="print-header">
          <h1>Vehicle Loading Details</h1>
          <p>Printed on ${printDate}</p>
        </div>

        <div class="vehicle-header">
          <h2>${data.vehicle_id || "N/A"}</h2>
        </div>

        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-content">
              <span class="stat-label">Total Loadings</span>
              <span class="stat-value">${data.totalLoadings || 0}</span>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-content">
              <span class="stat-label">Total Shipments</span>
              <span class="stat-value">${data.totalShipments || 0}</span>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-content">
              <span class="stat-label">Total Weight</span>
              <div class="weight-container">
                <span class="stat-value">${data.totalWeight || 0}</span>
                <span class="weight-unit">kg</span>
              </div>
            </div>
          </div>
        </div>

        <div class="shipments-table-container">
          <table class="shipments-table">
            <thead>
              <tr>
                <th>Shipment ID</th>
                <th>Loading ID</th>
                <th>Sender Name</th>
                <th>Receiver Name</th>
                <th>Receiver Phone</th>
                <th>Weight (kg)</th>
                <th>Loading Date</th>
              </tr>
            </thead>
            <tbody>
              ${
                data.shipments && data.shipments.length > 0
                  ? data.shipments
                      .map(
                        (shipment) => `
                      <tr>
                        <td>${shipment.shipmentId || "N/A"}</td>
                        <td>${shipment.loadingId || "N/A"}</td>
                        <td>${shipment.senderName || "N/A"}</td>
                        <td>${shipment.receiverName || "N/A"}</td>
                        <td>${shipment.receiverPhone || "N/A"}</td>
                        <td>${shipment.weight || 0} kg</td>
                        <td>${
                          shipment.loadingTime
                            ? new Date(shipment.loadingTime).toLocaleDateString()
                            : "N/A"
                        }</td>
                      </tr>
                    `
                      )
                      .join("")
                  : '<tr><td colspan="7" style="text-align: center; padding: 20px;">No shipments found</td></tr>'
              }
            </tbody>
          </table>
        </div>
      `;

      // Auto-print after a short delay
      setTimeout(() => {
        printWindow.print();
      }, 500);
    } else {
      console.error("print-content element not found");
    }
  }, 100);
};
